import React, { useState, useEffect } from 'react';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import { CUSTOM_EVENTS } from '../../utils/constants';

function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
}
SlideTransition.propTypes = {
    props: PropTypes.object
};

const Notify = () => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [notifKey, setNotifKey] = useState(new Date().getTime());

    const handleClose = () => setOpen(false);

    useEffect(() => {
      const toggleNotify = (e) => {
        const open = e.detail?.open;
        const message = e.detail?.message;
        setOpen(open);
        setMessage(message);
        setNotifKey(new Date().getTime());
      };

      document.addEventListener(CUSTOM_EVENTS.TOGGLE_NOTIFY, toggleNotify);

      return () => {
        document.removeEventListener(CUSTOM_EVENTS.TOGGLE_NOTIFY, toggleNotify);
      };
    }, []);

    return (
        <Snackbar
            key={notifKey}
            open={open}
            onClose={handleClose}
            TransitionComponent={SlideTransition}
            message={message}
            // key={state.Transition.name}
            autoHideDuration={1200}
        />
    );
};
// Notify.propTypes = {
//     message: PropTypes.string.isRequired,
//     // toggleNotify: PropTypes.func.isRequired,
// };

export default Notify;